import { useEffect } from 'react';
import { useEditorStore } from '../stores/editorStore';

export const useKeyboardShortcuts = () => {
  const {
    selectedElementId,
    removeElement,
    duplicateElement,
  } = useEditorStore();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ignore when typing in input fields
      const activeEl = document.activeElement;
      const tagName = activeEl?.tagName?.toUpperCase();
      if (tagName === 'INPUT' || tagName === 'TEXTAREA' || (activeEl as HTMLElement)?.isContentEditable) {
        return;
      }

      // Delete element
      if (e.key === 'Delete' && selectedElementId) {
        removeElement(selectedElementId);
        return;
      }

      // Duplicate (Ctrl+D)
      if (e.ctrlKey && e.key === 'd' && selectedElementId) {
        e.preventDefault();
        duplicateElement(selectedElementId);
        return;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedElementId, removeElement, duplicateElement]);
};
